import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { Store } from './redux/store/store';
import { ContextProvider } from './redux/Context';
// Side-effect import: registers the shared request timeout, retry and session-renewal
// interceptors once, before the first component mounts and fetches.
import './utils/config/apiClient';
import { purgeLegacyRememberMe } from './utils/helper/helper';
import { purgeLegacyNotificationKeys } from './utils/helper/notifications';
// import MetaPixel from './MetaPixel';
// import AdComponent from './AdComponent';

// FE-01: before anything renders, so no page ever runs with the old encrypted-password blob present.
purgeLegacyRememberMe();
// #196: the bell's pre-#196 keys, which no sign-out used to remove.
purgeLegacyNotificationKeys();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={Store}>
        <ContextProvider>
            {/* <MetaPixel /> */}
            {/* <AdComponent/> */}
            <App />
        </ContextProvider>
    </Provider>
);
reportWebVitals();
